import { SearchResultTabType } from "@/consts/tabType";
import { FC, ReactNode, PropsWithChildren } from "react";
import { MakerResponse } from "@/web-client/api";
import TabsLayout from "@/components/TabsLayout";
import useTabs from "@/components/SearchResultGroup/hooks/useTabs";

interface Props {
  keyword: string;
  tabType: SearchResultTabType;
  makers?: MakerResponse[];
  toggle?: ReactNode;
}

const SearchResultGroup: FC<PropsWithChildren<Props>> = ({
  keyword,
  tabType,
  children,
}) => {
  const tabs = useTabs(tabType, keyword);

  return (
    <div className="p-16 space-y-32 laptop:p-40 laptop:space-y-40">
      <div>
        <small className="text-xs font-bold text-secondary">検索ワード</small>
        <h1 className="text-2xl laptop:text-4xl font-bold">
          &rdquo;{keyword}&rdquo;
        </h1>
      </div>

      <TabsLayout tabs={tabs}>{children}</TabsLayout>
    </div>
  );
};

export default SearchResultGroup;
